module.exports = __webpack_public_path__ + "img/company-team-5.971ff5fc.jpg";